import type { EditorDocument, Layer } from '../core/model';
import { IDENTITY_MATRIX, type Matrix } from '../core/geometry';
import type { Viewport } from './renderer';

export interface ExtensionRenderContext {
  context: CanvasRenderingContext2D;
  document?: EditorDocument;
  viewport: Viewport;
  parentTransform: Matrix;
}

export type ExtensionLayerRenderer<TLayer extends Layer = Layer> = (layer: TLayer, renderContext: ExtensionRenderContext) => void;

const renderers = new Map<Layer['kind'], ExtensionLayerRenderer>();
let generation = 0;

export function registerExtensionLayerRenderer<TLayer extends Layer>(kind: TLayer['kind'], renderer: ExtensionLayerRenderer<TLayer>): () => void {
  renderers.set(kind, renderer as ExtensionLayerRenderer);
  generation += 1;
  return () => { renderers.delete(kind); generation += 1; };
}

export function renderExtensionLayer(layer: Layer, renderContext: ExtensionRenderContext): boolean {
  const renderer = renderers.get(layer.kind);
  if (!renderer) return false;
  renderer(layer, renderContext);
  return true;
}

export function defaultExtensionParentTransform(): Matrix { return IDENTITY_MATRIX; }

export function extensionRendererGeneration(): number { return generation; }
